import {
  DestinationMapTooltipContent
} from "@components/destination-map/destination-map-tooltip/destination-map-tooltip.component";

export interface TooltipContentModel {
  contentHTML?: string;
  destinationMapTooltipContent?: DestinationMapTooltipContent;
  isDestinationMapTooltip?: boolean;
  showOnClick?: boolean;
  subtitle?: string;
  title?: string;
}

export enum TooltipPosition {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}

export interface TooltipConfigModel {
  arrowPosition?: string;
  leftPosition?: number;
  maxWidth?: string;
  tooltipPosition?: TooltipPosition | null;
  topPosition?: number | null;
}
